// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__XU8WQ","fullscreen":"Loader_fullscreen__W9ehc","message":"Loader_message__A0fVa"};